module.exports = __webpack_public_path__ + "fonts/FetteUNZFraktur.3d17f924.ttf";